/**
 * Streaming Types
 *
 * Shared type definitions for incremental JSON parsing + tool-call streaming.
 */
export const DEFAULT_ON_DECK_CONFIG = {
    edit: 3,
    format: 2,
    chart: 1,
    search: 2,
    research: 2,
    default: 3,
};
